import React, {
  createContext,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from "react";

const GUI_CONFIG = {
  activeNavigation: "",
  isTracksNavigation: false,
  isProfilesNavigation: false,
  navigationKeys: ["statistics", "splits", "wayPoints", "trackProfiles"],
};

export const GuiContext = createContext();

export const GuiProvider = ({ children }) => {
  const [infoPanelExpanded, setInfoPanelExpanded] = useState(false);
  const [activeNavigation, setActiveNavigation] = useState(
    GUI_CONFIG.activeNavigation,
  );

  const [isTracksNavigation, setIsTracksNavigation] = useState(
    GUI_CONFIG.isTracksNavigation,
  );
  const [isProfilesNavigation, setIsProfilesNavigation] = useState(
    GUI_CONFIG.isProfilesNavigation,
  );

  const handleToggleNavigation = useCallback((key) => {
    setActiveNavigation((prev) => (prev === key ? "" : key));
  }, []);

  // Side effect: close info panel when navigation is closed
  useEffect(() => {
    if (!activeNavigation) {
      setInfoPanelExpanded(false);
    }
  }, [activeNavigation]);

  // Derived state
  const trackNavigation = useMemo(() => {
    return GUI_CONFIG.navigationKeys.reduce((acc, key) => {
      acc[key] = activeNavigation === key;
      return acc;
    }, {});
  }, [activeNavigation]);

  const value = useMemo(
    () => ({
      infoPanelExpanded,
      setInfoPanelExpanded,
      isTracksNavigation,
      setIsTracksNavigation,
      currentTrackNavigation: activeNavigation,
      isTrackNavigation: !!activeNavigation,
      isProfilesNavigation,
      setIsProfilesNavigation,
      trackNavigation,
      setTrackNavigation: handleToggleNavigation,
    }),
    [
      infoPanelExpanded,
      isTracksNavigation,
      activeNavigation,
      isProfilesNavigation,
      trackNavigation,
      handleToggleNavigation,
    ],
  );

  return <GuiContext.Provider value={value}>{children}</GuiContext.Provider>;
};
